import { Divider } from '@treezor/design-system';

export const designFormattedList = (data: Array<{}>) => {
  return data.map((item, index) => (
    <div key={Object.keys(item)[0]} className="flex flex-col">
      {Object.keys(item)?.map((key) => (
        <div key={key}>
          <div className="flex items-center justify-between my-2 gap-3">
            <span className="typo-body-semibold-small text-secondary">{key}</span>
            <span className="typo-body-regular-small text-helper">{item[key]}</span>
          </div>
          {index !== data.length - 1 && <Divider />}
        </div>
      ))}
    </div>
  ));
};

export const getPermsGroup = (defaultPermsGroup?: string) => {
  let index = -1;
  if (defaultPermsGroup && defaultPermsGroup.length) {
    const nbSubstring = defaultPermsGroup.length;
    index = parseInt(defaultPermsGroup.substring(nbSubstring - 2, nbSubstring));
  }

  const nfc = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1];
  const atm = [0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1];
  const online = [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 1];
  const foreign = [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1];
  const pinUnverified = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1];

  return {
    atm: index > 0 ? atm[index - 1] : 0,
    foreign: index > 0 ? foreign[index - 1] : 0,
    nfc: index > 0 ? nfc[index - 1] : 0,
    online: index > 0 ? online[index - 1] : 0,
    pinUnverified: index > 0 ? pinUnverified[index - 1] : 0,
  };
};
